export default __webpack_public_path__ + "static/media/logo.05bee097.png";